<router-outlet></router-outlet>
<xpw-overlay></xpw-overlay>
<xpw-file-import-popup />
<xpw-image-upload-popup />
<xpw-confirm-dialog />
<xpw-ai-assistant></xpw-ai-assistant>
